import React from 'react'
import { SvgIconProps } from './Home'

const SvgArrowBackIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "24"}
    height={height ?? "24"}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill ?? "#95358F"}
      d="M19.714 10.559H7.592L10.53 7.47c.275-.31.367-.618.367-1.03 0-.412-.184-.72-.367-1.03C10.255 5.104 9.888 5 9.52 5c-.368 0-.643.103-.919.412L3.367 10.97C3.184 11.279 3 11.588 3 12c0 .412.184.72.367 1.03l5.235 5.558c.184.206.551.412.918.412.368 0 .643-.103.919-.412.275-.206.367-.617.367-1.03 0-.41-.184-.823-.367-1.029l-2.847-3.088h12.122C20.45 13.441 21 12.823 21 12c0-.823-.551-1.441-1.286-1.441z"
    ></path>
  </svg>
)

export default SvgArrowBackIcon
